import { useState } from "react";
import { useListingsStore, useTitleStore } from "store";
import { RemoveTitleCompanyFunction } from "types/functions/removeTitleCompany";
import { BaseAsyncHook } from "types/hooks";

interface UseRemoveTitleCompany extends BaseAsyncHook {
  removeTitleCompany: RemoveTitleCompanyFunction;
}

export const useRemoveTitleCompany = (): UseRemoveTitleCompany => {
  const _removeTitleCompany = useTitleStore((state) => state.removeListing);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const removeTitleCompany = async (
    ...args: Parameters<RemoveTitleCompanyFunction>
  ) => {
    try {
      setIsLoading(true);
      setIsError(false);
      const response = await _removeTitleCompany(args[0]);
      return response;
    } catch (error) {
      setIsError(true);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error: isError,
    loading: isLoading,
    removeTitleCompany,
  };
};
